import styled from "@emotion/styled";
import { css } from "@emotion/react";

interface LoaderWrapperProps {
	fixed: boolean;
}

export const LoaderWrapper = styled.div<LoaderWrapperProps>`
	left: 0;
	top: 0;
	background-color: #fff;
	z-index: 900;
	display: flex;
	align-items: center;
	justify-content: center;

	${({ fixed }) =>
		fixed
			? css`
					position: fixed;
					width: 100vw;
					height: 100vh;
			  `
			: css`
					position: absolute;
					width: 100%;
					height: 100%;
			  `}
`;
